export const WAIT_FOR_STATE_TO_MATCH = 'WAIT_FOR_STATE_TO_MATCH';
